import { Link } from 'react-router-dom';
import { RTBLogo } from '@/components/RTBLogo';
import { Target, Users, BookOpen, Shield } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100 py-4 px-6">
        <Link to="/" className="inline-block"><RTBLogo className="h-8" /></Link>
      </header>
      <div className="max-w-3xl mx-auto px-6 py-12" data-testid="about-page">
        <h1 className="text-3xl font-oswald font-bold text-gray-900 mb-4">About ReadyToBuildIt.life</h1>
        <p className="text-gray-500 text-lg mb-10">Empowering entrepreneurs to build lasting wealth through structured mentorship and real-world business education.</p>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {[
            { icon: Target, title: 'Our Mission', desc: 'To provide accessible, actionable education that helps aspiring entrepreneurs create legitimate business entities and build sustainable income streams.' },
            { icon: Users, title: 'Who We Serve', desc: 'Individuals ready to take control of their financial future — from first-time entrepreneurs to experienced professionals looking to diversify.' },
            { icon: BookOpen, title: 'The 20-Day Program', desc: 'A structured, hands-on program covering LLC formation, business strategy, tax advantages, and wealth-building fundamentals with daily milestones.' },
            { icon: Shield, title: 'Our Commitment', desc: 'We believe in transparency, accessibility, and real results. Our program is designed to deliver practical value from day one.' },
          ].map(item => (
            <div key={item.title} className="p-6 border border-gray-100 rounded-xl">
              <item.icon className="w-8 h-8 text-rtb-purple mb-3" />
              <h3 className="font-oswald font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-100 pt-8">
          <h2 className="text-xl font-oswald font-bold text-gray-900 mb-4">Contact Us</h2>
          <p className="text-gray-500 text-sm">
            Have questions? Reach out to us at{' '}
            <a href="mailto:support@readytobuildit.life" className="text-rtb-purple font-medium">support@readytobuildit.life</a>
          </p>
        </div>
      </div>
    </div>
  );
}
